<ng-container *ngIf="message.payload" [ngSwitch]="message.payload.type">

	<div *ngSwitchCase="'text'" class="chat-message-item-simple"
		[ngClass]="{'float-left': message.senderName == 'watson','float-right': message.senderName == 'user'}">
		<div class="chat-message chat-message-{{message.senderName}} animated fadeIn">
			<app-chat-message-text [index]="index" [elements]="message"></app-chat-message-text>
			<!-- <div class="message-datetime" text-right>{{ message.time | date: 'hh:mm a' }}</div> -->
		</div>
	</div>

	<div *ngSwitchCase="'list-ordered'" class="chat-message-item-simple"
		[ngClass]="{'float-left': message.senderName == 'watson','float-right': message.senderName == 'user'}">
		<div class="chat-message chat-message-{{message.senderName}} animated fadeIn">
			<app-chat-message-list-ordered [index]="index" [elements]="message"></app-chat-message-list-ordered>
			<!-- <div class="message-datetime" text-right>{{ message.time | date: 'hh:mm a' }}</div> -->
		</div>
	</div>

	<div *ngSwitchCase="'list-unordered'" class="chat-message-item-simple"
		[ngClass]="{'float-left': message.senderName == 'watson','float-right': message.senderName == 'user'}">
		<div class="chat-message chat-message-{{message.senderName}} animated fadeIn">
			<app-chat-message-list-unordered [index]="index" [elements]="message"></app-chat-message-list-unordered>
			<!-- <div class="message-datetime" text-right>{{ message.time | date: 'hh:mm a' }}</div> -->
		</div>
	</div>

	<div *ngSwitchCase="'button-intent'" class="chat-message-item-simple"
		[ngClass]="{'float-left': message.senderName == 'watson','float-right': message.senderName == 'user'}">
		<div class="chat-message chat-message-{{message.senderName}} animated fadeIn">
			<app-chat-message-button-intent [index]="index" [elements]="message"
				(onOptionMessageClicked)="retrieveMessage($event)"></app-chat-message-button-intent>
			<!-- <div class="message-datetime" text-right>{{ message.time | date: 'hh:mm a' }}</div> -->
		</div>
	</div>

	<div *ngSwitchCase="'links'" class="chat-message-item-simple"
		[ngClass]="{'float-left': message.senderName == 'watson','float-right': message.senderName == 'user'}">
		<div class="chat-message chat-message-{{message.senderName}} animated fadeIn">
			<app-chat-message-button-link [index]="index" [elements]="message"></app-chat-message-button-link>
			<!-- <div class="message-datetime" text-right>{{ message.time | date: 'hh:mm a' }}</div> -->
		</div>
	</div>

	<div *ngSwitchCase="'carrusel'" class="chat-message-item-complex"
		[ngClass]="{'float-left': message.senderName == 'watson','float-right': message.senderName == 'user'}">
		<app-chat-message-carrusel [index]="index" [elements]="message"
			(onOptionMessageClicked)="retrieveMessage($event)"></app-chat-message-carrusel>
	</div>

	<div *ngSwitchCase="'list'" class="chat-message-item-complex"
		[ngClass]="{'float-left': message.senderName == 'watson','float-right': message.senderName == 'user'}">
		<app-chat-message-list-options [index]="index" [elements]="message"
			(onOptionMessageClicked)="retrieveMessage($event)"></app-chat-message-list-options>
	</div>

	<ng-container *ngSwitchCase="'quick-reply'">
		<div class="chat-message-item-simple"
			[ngClass]="{'float-left': message.senderName == 'watson','float-right': message.senderName == 'user'}">
			<div class="chat-message chat-message-{{message.senderName}} animated fadeIn">
				<div class="message-text">
					<div class="text">{{ message.payload.text[0] }}</div>
				</div>
			</div>
		</div>
		<div class="chat-message-item-complex"
			[ngClass]="{'float-left': message.senderName == 'watson','float-right': message.senderName == 'user'}">
			<app-chat-messages-quick-reply [index]="index" [elements]="message"
				(onOptionMessageClicked)="retrieveMessage($event)"></app-chat-messages-quick-reply>
		</div>
	</ng-container>

	<div *ngSwitchDefault class="chat-message-item-simple"
		[ngClass]="{'float-left': message.senderName == 'watson','float-right': message.senderName == 'user'}">
		<div class="chat-message chat-message-{{message.senderName}} animated fadeIn">
			<!-- Do nothing -->
			<!-- <div class="message-datetime" text-right>{{ message.time | date: 'hh:mm a' }}</div> -->
		</div>
	</div>

</ng-container>